import { render } from "./복리후생.vue?vue&type=template&id=1f005dbd"
import script from "./복리후생.vue?vue&type=script&lang=js"
export * from "./복리후생.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__